import React, { useState } from "react";
import ReactDOM from "react-dom";
import NavigoServices from "../../../services/NavigoServices";
import { useHistory } from "react-router";
export const HistoryCard = ({
  name,
  status,
  bookingId,
  consultDate,
  bookDate,
  patientName,
  appointmentId,
  patientId,
  appointmentData,
  onRefresh,
}) => {
  const history = useHistory();
  const [cancelLoading, setCancelLoading] = useState(false);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleConfirmCancel = () => {
    const payload = {
      appointmentId,
      status: 3,
    };

    setCancelLoading(true);

    NavigoServices.cancelAppointment(payload)
      .then(() => {
        setCancelLoading(false);
        setShowModal(false);

        // 👇 THIS reloads entire list
        onRefresh && onRefresh();
      })
      .catch(() => {
        setCancelLoading(false);
        setShowModal(false);
      });
  };
  const checkReschedule = () => {
    const payload = {
      appointmentId,
    };

    setRescheduleLoading(true);
    NavigoServices.checkReschedule(payload)
      .then(() => {
        navigateToReschedule();
      })
      .catch((err) => {
        console.error("Reschedule check failed:", err);
        setRescheduleLoading(false);
      });
  };

  const navigateToReschedule = () => {
    const appt = appointmentData || {};

    console.log("Reschedule - Full appointmentData:", JSON.stringify(appt));

    // Fetch provider info for min/max booking days
    const slotPayload = {
      pageNum: 0,
      pageSize: 0,
      planId: appt.planID,
      serviceId: appt.serviceID,
      serviceMode: appt.mode,
      patientId: appt.patientID || patientId,
      memberPatientId: appt.bookedFor || 0,
      serviceProviderIds: appt.serviceProviderID
        ? [appt.serviceProviderID]
        : [],
      vendorCode: appt.vendorCode || "",
      vendorDoctorId: appt.vendorDoctorId || 0,
      vendorId: appt.vendorId || "",
      geolocationFilter: null,
      languageMatch: [],
      locationFilter: [],
      providerAddressId: "",
    };

    NavigoServices.getAllTimeSlot(slotPayload)
      .then((slotRes) => {
        let provider = {
          id: appt.serviceProviderID || "",
          minBookingDays: 0,
          maxBookingDays: 7,
        };
        if (slotRes?.data?.providers?.length) {
          provider = slotRes.data.providers[0];
        }

        const navState = {
          provider,
          service: {
            planId: appt.planID,
            serviceId: appt.serviceID,
            serviceModeDetails: [{ modeName: appt.mode }],
          },
          appointment: {
            ID: appt.ID || appt.id || appointmentId,
            addressId: appt.addressId || "",
            vendorId: appt.vendorId || "",
            vendorCode: appt.vendorCode || "",
            displayName: appt.displayName || patientName || "",
            appointmentDate: appt.appointmentDate,
            timeSlot: appt.timeSlot,
            bookedFor: appt.bookedFor || 0,
            serviceName: appt.serviceName || name,
          },
        };
        sessionStorage.setItem("rescheduleData", JSON.stringify(navState));
        history.push({ pathname: "/navigoRes", state: navState });
        setRescheduleLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching provider:", err);
        const navState = {
          provider: {
            id: appt.serviceProviderID || "",
            minBookingDays: 0,
            maxBookingDays: 7,
          },
          service: {
            planId: appt.planID,
            serviceId: appt.serviceID,
            serviceModeDetails: [{ modeName: appt.mode }],
          },
          appointment: {
            ID: appt.ID || appt.id || appointmentId,
            addressId: appt.addressId || "",
            vendorId: appt.vendorId || "",
            vendorCode: appt.vendorCode || "",
            displayName: appt.displayName || patientName || "",
            appointmentDate: appt.appointmentDate,
            timeSlot: appt.timeSlot,
            bookedFor: appt.bookedFor || 0,
            serviceName: appt.serviceName || name,
          },
        };
        sessionStorage.setItem("rescheduleData", JSON.stringify(navState));
        history.push({ pathname: "/navigoRes", state: navState });
        setRescheduleLoading(false);
      });
  };
  return (
    <>
      <div className="booking-history-card">
        <div className="booking-history-card-ele">
          <b>{name}</b>
          <p
            className={
              status === 2
                ? "status-completed"
                : status === 3
                ? "status-cancelled"
                : "status-ongoing"
            }
          >
            {status === 2
              ? "Completed"
              : status === 3
              ? "Cancelled"
              : "Ongoing"}
          </p>
        </div>
        <div className="booking-history-card-ele">
          <p>Booked for</p>
          <p>{patientName}</p>
        </div>
        <div className="booking-history-card-ele">
          <p>Booking ID</p>
          <p>{bookingId}</p>
        </div>
        <div className="booking-history-card-ele">
          <p>Consultation date</p>
          <p>{consultDate}</p>
        </div>
        <div className="booking-history-card-ele">
          <p>Booking date</p>
          <p>{bookDate}</p>
        </div>
        {status !== 2 && status !== 3 && (
          <div className="booking-history-actions">
            <button
              className="btn-cancel"
              onClick={() => setShowModal(true)}
              disabled={cancelLoading || rescheduleLoading}
            >
              {cancelLoading ? "Cancelling..." : "Cancel"}
            </button>

            <button
              className="btn-reschedule"
              onClick={() => checkReschedule()}
              disabled={cancelLoading || rescheduleLoading}
            >
              {rescheduleLoading ? "Rescheduling..." : "Reschedule"}
            </button>
          </div>
        )}
      </div>
      {showModal &&
        /* Portaled to <body> on purpose.
         *
         * This sheet used to render inside .booking-history-card-container, a
         * sibling of .pagination-fixed (position: sticky, z-index: 5). Despite
         * the overlay's z-index: 9999 the pagination painted over the bottom of
         * the sheet, hiding Back/Confirm — the overlay was trapped in an
         * ancestor stacking context, so its z-index could only compete inside
         * that ancestor, never with the pagination.
         *
         * At body level there is no ancestor left to trap it, so it covers the
         * page whatever the rest of the tree does. */
        ReactDOM.createPortal(
          <div
            className="cancel-modal-overlay"
            /* Tapping the dimmed area dismisses, which is what a bottom sheet
             * is expected to do. Not while a cancel is in flight: the request
             * is already away and closing would leave the user unsure whether
             * it went through. */
            onClick={() => {
              if (!cancelLoading) setShowModal(false);
            }}
          >
            {/* Stop clicks inside the sheet from reaching the overlay above,
                or every tap on the sheet would close it. */}
            <div
              className="cancel-modal"
              onClick={(e) => e.stopPropagation()}
            >
            <h3>Are you sure?</h3>

            <p>
              Are you sure you want to cancel the appointment, if yes then click
              on confirm button to proceed
            </p>

            <div className="cancel-modal-actions">
              <button
                className="modal-back-btn"
                onClick={() => setShowModal(false)}
              >
                Back
              </button>

              <button
                className="modal-confirm-btn"
                onClick={handleConfirmCancel}
                disabled={cancelLoading}
              >
                {cancelLoading ? "Cancelling..." : "Confirm"}
              </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
